import classNames from 'classnames';
import { useParams } from 'react-router';
import { TemplateClassNames } from '../../../../../types/template-layouts';
import { PageModule } from '../../../../../types/working-model';
import { ParamsProps } from '../../../live-event';
import { getStylingOverrides } from '../../../utils';
import './description.scss';
import { TypographyItem } from '../../../../general-ui/typography-item/typography-item';
import ReactMarkdown from 'react-markdown';
import { getTextValue } from '../../../../../utils/utils';

interface DescriptionProps {
	module: PageModule;
	template: TemplateClassNames;
}
const SessionDescription: React.FC<DescriptionProps> = ({ module, template }) => {
	const params: ParamsProps = useParams();

	const language = params?.language || 'en';

	const { styling_overrides, content } = module;

	const stylingOverrides = getStylingOverrides(styling_overrides);
	const {
		titleOverrides,
		customHeadingOverrides,
		descriptionOverrides
	} = stylingOverrides;

	const { custom_heading, title, description } = getTextValue(content, language);

	return (
		<section className={classNames(
			'session-module description',
			stylingOverrides.backgroundColor,
			template
		)}
			style={stylingOverrides.backgroundImg}
		>
			<TypographyItem
				tagName="h5"
				className={classNames('evt-heading-5 custom-title', customHeadingOverrides)}
				template={template}
			>
				{custom_heading}
			</TypographyItem>
			<div className="description-content">
				<TypographyItem
					tagName="h3"
					className={classNames('evt-heading-3 title', titleOverrides)}
					template={template}
				>
					{title}
				</TypographyItem>
				<TypographyItem
					tagName="div"
					className={classNames('evt-body-text-1 description', descriptionOverrides)}
					template={template} >
					<ReactMarkdown source={description} />
				</TypographyItem>
			</div>
		</section>
	);
};

export default SessionDescription;